import { TimeUnit as EdgeTimeUnit } from 'generated/graphql';
import { AggregatePeriod, TimeUnit } from 'v2/core/entities';

const edgeTimeUnitToAggregatePeriod = (time: EdgeTimeUnit): AggregatePeriod => {
  switch (time) {
    case EdgeTimeUnit.Week:
      return AggregatePeriod.WEEK;
    case EdgeTimeUnit.Month:
      return AggregatePeriod.MONTH;
    case EdgeTimeUnit.Quarter:
      return AggregatePeriod.QUARTER;
    case EdgeTimeUnit.Year:
      return AggregatePeriod.YEAR;
    case EdgeTimeUnit.Hour: // not handled
    case EdgeTimeUnit.Minute: // not handled
    case EdgeTimeUnit.Second: // not handled
    case EdgeTimeUnit.Day:
      return AggregatePeriod.DAY;
  }
};

const timeUnitToEdgeTimeUnit = (time: TimeUnit): EdgeTimeUnit => {
  switch (time) {
    case TimeUnit.Week:
      return EdgeTimeUnit.Week;
    case TimeUnit.Month:
      return EdgeTimeUnit.Month;
    case TimeUnit.Quarter:
      return EdgeTimeUnit.Quarter;
    case TimeUnit.Year:
      return EdgeTimeUnit.Year;
    case TimeUnit.Day:
      return EdgeTimeUnit.Day;
  }
};

const timeUnitToAggregatePeriod = (time: TimeUnit): AggregatePeriod => {
  switch (time) {
    case TimeUnit.Week:
      return AggregatePeriod.WEEK;
    case TimeUnit.Month:
      return AggregatePeriod.MONTH;
    case TimeUnit.Quarter:
      return AggregatePeriod.QUARTER;
    case TimeUnit.Year:
      return AggregatePeriod.YEAR;
    case TimeUnit.Day:
      return AggregatePeriod.DAY;
  }
};

export {
  edgeTimeUnitToAggregatePeriod,
  timeUnitToAggregatePeriod,
  timeUnitToEdgeTimeUnit,
};
